const common = {
  skipToContent: "Aller au contenu",
  
  navBarMenu: {
    home: "Accueil",
    services: "Services",
    expertise: {
      title: "Expertise",
      blog: "Blog",
      activities: "Activités",
      cases: "Études de cas"
    },
    work: {
      title: "Réalisations",
      experience: "Expérience",
      projects: "Projets",
      technologies: "Technologies"
    },
    contact: "Contact",
    booking: "Prendre RDV"
  },

  activities: {
    types: {
      conference: "Conférence",
      meetup: "Meetup",
      training: "Formation",
      publication: "Publication",
      podcast: "Podcast"
    }
  },

  footer: {
    text: "Travaillons ensemble dès aujourd'hui !",
    footerMenuTitle: "Plan du site",
    footerMenu: [
      "Accueil",
      "Services",
      "Labs",
      "Technologies",
      "Expérience",
      "Projets",
      "Contact"
    ],
    cta: {
      titlePrefix: "Collaborons",
      titleHighlightCollaborate: "",
      titleMiddle: " et construisons quelque chose d’",
      titleHighlightAmazing: "incroyable",
      titleSuffix: " ensemble !",
      description: "Spécialisé dans les solutions IA prêtes production et les architectures web scalables."
    },
    contactLocation: "Île-de-France / Remote",
    admin: "Admin",
    legal: {
      privacy: "Politique de confidentialité",
      terms: "Conditions d’utilisation"
    },
    copyright: "© {{year}} Alexandre SANOU. Tous droits réservés."
  },

  socials: {
    title: "Réseaux sociaux",
    github: "GitHub",
    linkedIn: "LinkedIn"
  },

  buttons: {
    send: "Envoyer",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    back: "Retour",
    demo: "Démo",
    download: "Télécharger"
  },

  messages: {
    loading: "Chargement...",
    error: "Une erreur est survenue",
    success: "Opération réussie",
    noResults: "Aucun résultat",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ?"
  }
};

export default common;
